import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InstantSearch\InstantSearchPreviewController::__invoke
* @see app/Http/Controllers/InstantSearch/InstantSearchPreviewController.php
* @route '/api/instant-search/preview'
*/
const InstantSearchPreviewController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: InstantSearchPreviewController.url(options),
    method: 'get',
})

InstantSearchPreviewController.definition = {
    methods: ["get","head"],
    url: '/api/instant-search/preview',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InstantSearch\InstantSearchPreviewController::__invoke
* @see app/Http/Controllers/InstantSearch/InstantSearchPreviewController.php
* @route '/api/instant-search/preview'
*/
InstantSearchPreviewController.url = (options?: RouteQueryOptions) => {
    return InstantSearchPreviewController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InstantSearch\InstantSearchPreviewController::__invoke
* @see app/Http/Controllers/InstantSearch/InstantSearchPreviewController.php
* @route '/api/instant-search/preview'
*/
InstantSearchPreviewController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: InstantSearchPreviewController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InstantSearch\InstantSearchPreviewController::__invoke
* @see app/Http/Controllers/InstantSearch/InstantSearchPreviewController.php
* @route '/api/instant-search/preview'
*/
InstantSearchPreviewController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: InstantSearchPreviewController.url(options),
    method: 'head',
})

export default InstantSearchPreviewController